<div class="modal-header">
    <h5 class="modal-title">📢 Bildirim Detayı</h5>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <!-- Başlık -->
    <div class="mb-3">
        <h6 class="text-uppercase text-muted small mb-1">Başlık</h6>
        <p class="mb-0 font-weight-bold">{{ data.title }}</p>
    </div>

    <!-- Açıklama -->
    <div>
        <h6 class="text-uppercase text-muted small mb-1">Açıklama</h6>
        <p class="mb-0 text-dark" *ngIf="data.description; else noDesc">
            {{ data.description }}
        </p>
        <ng-template #noDesc>
            <p class="mb-0 text-muted">Açıklama bulunmamaktadır.</p>
        </ng-template>
    </div>
</div>